<template>
  <div>
    <el-upload
      ref="elUpload"
      :disabled="disabled"
      :action="uploadUrl"
      :on-change="handleChange"
      :on-exceed="handleExceed"
      :limit="maxUploadNum"
      :headers="headers"
      :show-file-list="true"
      :multiple="multiple"
      :on-success="onSuccess"
      :on-preview="onPreview"
      :before-upload="beforeUpload"
      :before-remove="beforeRemove"
      :file-list="fileList"
      :http-request="baiduUpload"
    >
      <div class="el-upload__text">
        <el-button size="small" type="primary">{{
          language === "cn" ? "点击上传" : "click on the upload"
        }}</el-button>
      </div>
      <div class="el-upload__tip" slot="tip" style="color: red">
        {{ tipText }}
      </div>
    </el-upload>
  </div>
</template>

<script>
import { getToken } from '../utils/auth'
import { deleteFile, uploadFileBos } from '../api/system/file'
import { listStorage } from '../api/system/objectStorage'
import { uploadFile } from './../utils/BaiduBosUploader'

export default {
  name: 'fileUploadBos',
  //      提示文字    是否多选上传  最大上传大小 允许上传的文件类型  允许最大上传的文件数量,0表示不限制    禁用上传     表单字段      文件标识   中英切换
  props: [
    'tipText',
    'multiple',
    'maxSize',
    'fileType',
    'maxUploadNum',
    'disabled',
    'labelField',
    'remark',
    'language'
  ],
  data () {
    return {
      remarkCopy: '',
      headers: { Authorization: 'Bearer ' + getToken() },
      fileList: [],
      fielNum: 0,
      storageList: [],
      uploadUrl: this.normalUploadUrl,
      uploadFalg: true
    }
  },
  async created () {
    this.remarkCopy = this.remark
    if (!this.remarkCopy) {
      this.remarkCopy = this.labelField + Math.random()
    }
    this.uploadUrl = this.normalUploadUrl + this.remarkCopy
    this.storageList = []
    await listStorage(this.systemURL, {
      remark: this.remarkCopy
    }).then(res => {
      if (res.rows && res.rows.length > 0) {
        res.rows.forEach(item => {
          if (item) {
            this.fileList.push({
              name: item.fileName,
              url: item.path
            })
            this.storageList.push(item)
          }
        })
      }
    })
  },
  methods: {
    async baiduUpload (params) {
      console.log('elupload', params)
      const progress = (e) => params.onProgress(e)
      try {
        const res = await uploadFile(params.file, progress)
        const data = {
          uid: params.file.uid,
          fileName: params.file.name,
          size: params.file.size,
          type: params.file.type,
          url: res.body.location,
          path: res.body.location,
          eTag: res.body.eTag,
          'x-bce-request-id': res.http_headers['x-bce-request-id'],
          remark: this.remarkCopy
        }

        // 对接业务
        uploadFileBos(this.systemURL, data).then(res => {
          console.log('res123123', res)
          params.onSuccess({
            ...data,
            id: res.data
          })
        })
        console.log('baidu bos upload res', res)
      } catch (error) {
        console.log('baidu bos upload error', error)
        params.onError(error)
      }
    },
    // 文件状态改变的回调方法，添加、上传成功、上传失败都会调用此方法
    handleChange (file, fileList) {
      this.fileList = fileList
    },
    // 限制最大上传数量
    handleExceed (files, fileList) {
      this.$message.warning(
        this.language === 'cn'
          ? `当前限制选择 ${this.maxUploadNum} 个文件，本次选择了 ${
            files.length
          } 个文件，共选择了 ${files.length + fileList.length} 个文件`
          : `Current restricted selection ${
            this.maxUploadNum
          } file，This time I chose ${
            files.length
          } file，A total of chose ${files.length + fileList.length} file`
      )
    },
    // 移除文件前的回调
    beforeRemove (file, fileList) {
      if (!this.uploadFalg) {
        return true
      }

      this.$confirm(
        this.language === 'cn'
          ? '您确定删除此文件吗?'
          : 'Are you sure to delete this file ?',
        this.language === 'cn' ? '提示' : 'Tip',
        {
          confirmButtonText: this.language === 'cn' ? '确定' : 'confirm',
          cancelButtonText: this.language === 'cn' ? '取消' : 'cancel',
          type: 'warning'
        }
      )
        .then(() => {
          let that = this
          this.storageList.forEach((s, index) => {
            if (s.fileName === file.name) {
              deleteFile(this.systemURL, s.id).then(res => {
                that.$message.success(
                  this.language === 'cn' ? '删除成功' : 'successfully delete'
                )
                that.storageList.splice(index, 1)
                that.fileList.forEach((f, index1) => {
                  if (s.fileName === f.name) {
                    that.fileList.splice(index1, 1)
                  }
                })
              })
            }
          })
        })
        .catch(() => {

        })
      return false
    },
    // 文件上传成功的回调
    onSuccess (response, file, fileList) {
      if (!response) {
        return
      }

      this.storageList.push(response)
      this.$message.success(
        this.language === 'cn' ? '上传成功' : 'successfully upload'
      )
      this.$emit('getRemark', this.labelField, this.remarkCopy)
    },
    // 点击文件列表中已上传的文件时的钩子
    onPreview (file) {
      this.storageList.forEach(s => {
        if (s.fileName === file.name) {
          window.open(s.path)
        }
      })
    },
    // 添加文件前的回调
    beforeUpload (file) {
      // 移除超过上传大小的文件
      if (this.maxSize) {
        if (file.size > this.maxSize) {
          this.$message.error(
            file.name +
              (this.language === 'cn'
                ? '超出最大上传大小:'
                : 'Exceeding the maximum upload size') +
              this.maxSize +
              (this.language === 'cn'
                ? 'Bytes,请上传符合大小的文件'
                : 'Bytes,Please upload the appropriate file size')
          )
          this.uploadFalg = false
          return false
        }
      }
      let ary = file.name.split('.')
      if (!this.fileType || this.fileType.length === 0) {
        this.uploadFalg = true
      } else {
        if (this.fileType.indexOf(ary[ary.length - 1]) !== -1) {
          this.uploadFalg = true
        } else {
          let type = ''
          this.fileType.forEach((item, index) => {
            type += item + (index === this.fileType.length - 1 ? '' : ',')
          })
          this.$message.error(
            (this.language === 'cn' ? '只能上传[ ' : 'Must be uploaded[ ') +
              type +
              (this.language === 'cn' ? ' ]类型的文件' : ' ]file type')
          )
          this.uploadFalg = false
        }
      }
      return this.uploadFalg
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/fileUploadBos.vue